var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.000363834 2.97659C-0.0101022 2.60353 0.20583 2.24285 0.576194 2.08223L0.578919 2.08105C0.957774 1.91956 1.38985 2.01414 1.66404 2.29755L5.99878 6.69142L10.3323 2.29882C10.5711 2.04859 10.9363 1.94007 11.2867 2.0328C11.6342 2.1253 11.8874 2.3942 11.9703 2.71427C12.0522 3.03245 11.9621 3.37766 11.7176 3.61735L6.69146 8.71207C6.3126 9.0961 5.68496 9.0961 5.30609 8.71207L0.278311 3.61571C0.105535 3.44328 0.00740788 3.214 0.000363834 2.97659Z","fill":"#001D3B"}));
}

Arrow.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
